import { PiChartBarDuotone } from "react-icons/pi";


export default function Dashboard() {
  return (
    <div className="flex justify-center">
      <div className="mt-32 flex flex-col items-center">
        <PiChartBarDuotone size={120} color="gray" />
        <div className="text-xs font-bold">SUMMARY</div>
        </div>
    </div>
  )
}
